import { Col, Row } from 'react-bootstrap'
import mobile from '../../assets/img/features/Recibe más pedidos.webp'
import calender from '../../assets/img/features/Llena tu calendario.webp'
import computer from '../../assets/img/features/Mejora tu operación.webp'
import increase from '../../assets/img/features/Aumenta tus ventas.webp'
import banquethall from '../../assets/img/features/Para_Proveedores.webp'
import banquethall2 from '../../assets/img/features/Para_Organizadores.webp'
import medal from '../../assets/img/features/Encuentra proveedores validados.webp'
import top from '../../assets/img/features/Reseñas de proveedores.webp'
import plan from '../../assets/img/features/Crea y administra eventos.webp'
import agree from '../../assets/img/features/Contrata con Confianza.webp'
import MyModal from '../common/MyModal'
import useModal from '../../hooks/useModal'
function Features() {
  const { showModal, handleCloseModal } = useModal() // custom hook for modal use
  return (
    <>
      <section className="bg-soft pt-15 border-bottom border-top">
        <div className="container-small">
          <Row>
            <Col>
              <h4 className="text-uppercase">Para</h4>
              <h1 className="fw-black text-gradient-info text-uppercase">Proveedores</h1>
              <div className="text-fiestr-gray pb-6 pt-2">
                Consolidados que quieren mejorar su operación y pequeños negocios que buscan crecer
                y expandirse.
              </div>
              <div>
                <Row className="text-center">
                  <Col className="">
                    <img className="" src={mobile} alt="mobile" width={100} />
                    <div className="fw-medium pt-3" style={{ whiteSpace: 'nowrap' }}>
                      Recibe mas pedidos
                    </div>
                  </Col>
                  <Col className="">
                    <img className="" src={calender} width={100} alt="calender" />
                    <div className="fw-medium pt-3 ">Llena tu calendario</div>
                  </Col>
                </Row>
                <Row className="text-center py-7">
                  <Col>
                    <img className="" src={computer} width={100} alt="comp" />
                    <div className="fw-medium  pt-3">Mejora tu operación</div>
                  </Col>
                  <Col>
                    <img className="" src={increase} width={100} alt="increase" />
                    <div className="fw-medium pt-3">Aumenta tus ventas</div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} lg={7} md={12} sm={12} className=" pe-lg-10 pt-lg-10">
              <div className="fw-medium text-center">
                <img className="w-100" src={banquethall} alt="Musician" />
              </div>
              <div className="text-center text-primary pt-5 fw-medium">
                {/* <Link onClick={handleShowModal} to="/">
                  Registrame como Proveedor
                </Link> */}
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <section className=" bg-soft pt-10 border-top border-bottom">
        <div className="container-small">
          <Row>
            <Col className="order-lg-1">
              <h4 className="text-uppercase">Para</h4>
              <h1 className="fw-black text-gradient-info text-uppercase">Organizadores</h1>
              <div className="text-fiestr-gray pb-6 pt-2">
                No importa si es tu propia fiesta o eres un organizador profesional, nuestras
                herramientas te ayudarán a hacer que tu evento sea todo un exito.
              </div>
              <div>
                <Row className="text-center">
                  <Col className="">
                    <img className="" src={medal} width={100} alt="mobile" />
                    <div
                      className="fw-medium pt-3"
                      // style={{ whiteSpace: "nowrap" }}
                    >
                      Encuentra proveedores validados
                    </div>
                  </Col>
                  <Col className="">
                    <img className="" src={top} width={100} alt="calender" />
                    <div className="fw-medium pt-3 ">Reseñas de proveedores</div>
                  </Col>
                </Row>
                <Row className="text-center py-7">
                  <Col className="">
                    <img className="" src={plan} width={100} alt="comp" />
                    <div className="fw-medium  pt-3">Crea y administra eventos</div>
                  </Col>
                  <Col>
                    <img src={agree} width={100} alt="increase" />
                    <div className="fw-medium pt-3">Contrata con confianza</div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={12} lg={7} md={12} sm={12} className=" pe-lg-10 pt-lg-10">
              <div className="fw-medium text-center">
                <img className="w-100" src={banquethall2} alt="Musician" />
              </div>
              {/* <div className="text-center text-primary pt-5 fw-medium">
                <Link onClick={handleShowModal} to="/">
                  Registrame como Organizador
                </Link>
              </div> */}
            </Col>
          </Row>
        </div>
        <MyModal show={showModal} onHide={handleCloseModal} />
      </section>
    </>
  )
}

export default Features
